import agentPlatformClient from "./agentPlatformClient.ts";

export const getAccountInfo = (agencyId) => {
  const url = "/api/v1/accounts/me";
  return agentPlatformClient.get(url, {
    withCredentials: false,
    headers: agencyId ? { "x-company-id": agencyId } : undefined,
  });
};

export const provisionTenant = (payload, agencyId) => {
  const url = "/api/v1/tenants/provision";
  // payload can be: { name: string, adminEmail?: string } OR { tenantID: string }
  return agentPlatformClient.post(url, payload, {
    withCredentials: false,
    headers: agencyId ? { "x-company-id": agencyId } : undefined,
  });
};

export const getTenantInfo = (agencyId) => {
  const url = "/api/v1/tenants/tenantInfo?agencyId=" + agencyId;
  return agentPlatformClient.get(url, {
    withCredentials: false,
  });
};
